import { render, staticRenderFns } from "./ReporteGeneralNew.vue?vue&type=template&id=56be63c8&"
import script from "./ReporteGeneralNew.vue?vue&type=script&lang=js&"
export * from "./ReporteGeneralNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports